import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { motion } from 'framer-motion';
import { useMutationMagicRename } from '../mutations/useMutationMagicRename.js';
import { IconShock } from '@fabric-app/icons/old';
import { Button } from '@fabric-app/ui/components/Button';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useBoolState } from '@fabric-app/hooks/useBooleanState';
import { FloatAnchor } from '@fabric-app/ui/components/FloatAnchor';
import { trimChars } from '@fabric-app/utils/text';

const StyledButton = styled(motion(Button)).attrs((p) => {
  return {
    size: "sm",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    variant: "bg-primary",
    ...p
  };
}).withConfig({
  displayName: "MagicRename__StyledButton",
  componentId: "sc-3921455b-0"
})([
  `pointer-events:auto;color:`,
  `;padding:0.5rem;z-index:127;transition:0.2s outline,0.2s box-shadow;`
], cssVar["color-app-primary-text"]);
const MagicRename = ({ children, resourceId, onRename, onFetch, onSettled }) => {
  const { mutate: mutateMagicRename, isPending, isError } = useMutationMagicRename();
  const openState = useBoolState();
  const requestNewName = async (e) => {
    if (!resourceId) return;
    e.preventDefault();
    e.stopPropagation();
    onFetch?.();
    mutateMagicRename(resourceId, {
      onSuccess: (name) => {
        onRename?.(trimChars(name, [
          '"',
          "'"
        ]));
      },
      onSettled
    });
  };
  return /* @__PURE__ */ jsxs(FloatAnchor.Root, {
    open: isPending || !resourceId || isError ? false : openState.value,
    setOpen: openState.set,
    children: [
      /* @__PURE__ */ jsx(FloatAnchor.Trigger, {
        action: "focus",
        asChild: true,
        children
      }),
      /* @__PURE__ */ jsx(FloatAnchor.Floating, {
        asChild: true,
        children: /* @__PURE__ */ jsxs(StyledButton, {
          onPointerDown: (e) => e.preventDefault(),
          onPointerUp: requestNewName,
          children: [
            /* @__PURE__ */ jsx(IconShock, {}),
            "Name this for me"
          ]
        })
      })
    ]
  });
};

export { MagicRename };
//# sourceMappingURL=MagicRename.js.map
